import { useEffect } from 'react';
import { Terminal } from '@/surfaces/Terminal/Terminal';
import { HUDBar } from '@/components/HUDBar';
import { TVTickerStrip } from '@/components/TVTickerStrip';
import { SurfaceDock } from '@/components/SurfaceDock';
import { SurfaceOverlay } from '@/components/SurfaceOverlay';
import { NotificationDock } from '@/components/NotificationDock';
import { StatsDashboard } from '@/components/StatsDashboard';
import { CinematicTakeover } from '@/components/CinematicTakeover';
import { SettingsPanel } from '@/components/SettingsPanel';
import { BootSequence } from '@/components/BootSequence';
import { KeyboardHelp } from '@/components/KeyboardHelp';
import { PnlFlash } from '@/components/PnlFlash';
import { FirstTimeHint } from '@/components/FirstTimeHint';
import { useMarkets } from '@/state/markets';
import { listAll, getTicker } from '@/content/tickers';

export default function App() {
  // [ / ] cycle the active ticker within the SAME category. Lets keyboard-only
  // players hop names without opening the watchlist.
  // M cycles among held positions (jump-to-mine).
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const target = e.target as HTMLElement | null;
      if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA') return;
      if (e.key === '[' || e.key === ']') {
        const cur = useMarkets.getState().activeTickerId;
        const curCfg = getTicker(cur);
        if (!curCfg) return;
        const peers = listAll().filter((t) => t.category === curCfg.category);
        const idx = peers.findIndex((t) => t.id === cur);
        if (idx < 0) return;
        const dir = e.key === ']' ? 1 : -1;
        const next = peers[(idx + dir + peers.length) % peers.length];
        if (next) useMarkets.getState().setActiveTicker(next.id);
      } else if (e.key === 'm' || e.key === 'M') {
        const m = useMarkets.getState();
        if (m.positions.length === 0) return;
        const cur = m.activeTickerId;
        const heldIds = m.positions.map((p) => p.ticker);
        const curIdx = heldIds.indexOf(cur);
        const next = heldIds[curIdx >= 0 ? (curIdx + 1) % heldIds.length : 0];
        if (next) m.setActiveTicker(next);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex h-dvh w-dvw flex-col bg-bg-deep text-text-primary font-mono overflow-hidden">
      <HUDBar />
      <main className="flex-1 min-h-0 overflow-hidden">
        <Terminal />
      </main>
      <SurfaceDock />
      <TVTickerStrip />
      <SurfaceOverlay />
      <NotificationDock />
      <StatsDashboard />
      <SettingsPanel />
      <CinematicTakeover />
      <BootSequence />
      <KeyboardHelp />
      <PnlFlash />
      <FirstTimeHint />
    </div>
  );
}
